<template>
<div class="regional-tab">
	<button @click="goToRegionalStatistics()" class="button primary">
		Newly Registered Companies
	</button>
	<button @click="goToRegionalStatistics()" class="button primary">
		Unemployment Rate
	</button>
	<button @click="goToRegionalStatistics()" class="button primary">
		2018 Issued Capital by Sector
	</button>
</div>
</template>

<script>
export default {
	methods: {
		goToRegionalStatistics() {
			this.$router.push({
				name: 'regional-statistics',
				query: {
					...this.$route.query,
					opportunityId: this.$route.params.opportunityId
				}
			})
		}
	}
}
</script>

<style lang="scss">
.regional-tab {
	display: inline-table;

	.button {
		font-weight: 400;
		width: auto;
		font-size: 14px;
		text-transform: capitalize;
		padding: 6px 15px;
		float: left;
		margin: 0px 9px 7px 0px;

		&:last-child {
			margin-bottom: 0px;
		}
	}
}
</style>
